import {Component, Input, OnInit} from '@angular/core';
import {statesCaptionEntities} from '@shared/constants/states-caption.constants';
import {radioStudioTypeCodes} from '@modules/container/request/constants/request.constants';
import {MedicalTestService} from '@shared/services/medical-test.service';
import {IdName} from '@core/src/public-api';

@Component({
  selector: 'si-mtest-medical-test-item-results',
  templateUrl: './mtest-medical-test-item-results.component.html',
  styleUrls: ['./mtest-medical-test-item-results.component.scss']
})
export class MtestMedicalTestItemResultsComponent implements OnInit {
  @Input() requestId: number;
  @Input() requestDate: number;
  @Input() appointmentStartDate: number;
  @Input() performedDate: number;
  @Input() performedResultsDate: number;
  @Input() centerName: string;
  @Input() serviceName: string;
  @Input() requestTypeName: string;
  @Input() requestTypeId: number;
  @Input() requestStateId: number;
  @Input() radioStudioTypeCode: string;
  @Input() benefitTypeName: string;
  @Input() title: string;
  @Input() alfrescoGuid: string;
  @Input() openTop: boolean;
  @Input() images: IdName[];
  statesCaptionEntities = statesCaptionEntities;
  areResultsAvailable: boolean;
  useCaseDateText: string;
  useCaseDate: number;
  private _actions: string[];

  constructor(
    private medicalTestService: MedicalTestService
  ) {
  }

  get actions(): string[] {
    return this._actions;
  }

  @Input()
  set actions(val) {
    this._actions = val;
    this.checkResultsAvailable();
  }

  ngOnInit(): void {
    this.setUseCaseDateAndText();
  }

  checkResultsAvailable(): void {
    this.areResultsAvailable = this.medicalTestService.checkResultsAvailable(this.radioStudioTypeCode, this.actions);
  }

  setUseCaseDateAndText(): void {
    switch (this.radioStudioTypeCode) {
      case radioStudioTypeCodes.TELERADIOLOGY:
        this.useCaseDateText = this.areResultsAvailable ? 'SI_PERFORMED_ON' : 'SI_RECEIVED_ON';
        this.useCaseDate = this.areResultsAvailable ? this.performedResultsDate : this.requestDate;
        break;
      default:
        this.useCaseDateText = 'SI_PERFORMED_ON';
        this.useCaseDate = this.performedDate || this.appointmentStartDate;
        break;
    }
  }
}
